/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:87c3077c-8170-45a2-8dd2-7718ce209928",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_ESoyCcSoJ",
    "aws_user_pools_web_client_id": "3a7q7cj9dv9v8772tuschubp2n",
    "oauth": {},
    "aws_content_delivery_bucket": "iauai-20200725170124-hostingbucket-dev",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "http://iauai-20200725170124-hostingbucket-dev.s3-website-us-east-1.amazonaws.com"
};


export default awsmobile;
